import { withCurrentParams } from 'actions/utils';
import { BROADCAST_DELETE_LIVE_RECORDING } from 'actions/Types';
import { BROADCAST_RECORDING_DELETE } from 'store/eventConstants';

/**
 * Delete a recording
 * @param recordingId
 */
export default recordingId => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        meeting: { attendeeResponse }
      } = getState();
      const action = {
        type: BROADCAST_DELETE_LIVE_RECORDING,
        request: async apiClient => {
          const resp = await apiClient.broadcast.deleteRecording(
            teamId,
            eventId,
            broadcastId,
            recordingId
          );
          // notify other directors
          socket.emit(BROADCAST_RECORDING_DELETE, {
            broadcastId,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });
          return resp;
        }
      };
      dispatch(action);
    }
  );
};
